"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.beramain = void 0;
exports.beramain = {
    "addresses": {
        "ProxyAdmin": "0xF04B152d2E27b5d975A2eb6b7F39EA42A74841Ac",
        "Multicall2": "0xcA11bde05977b3631167028862bE2a173976CA11",
        "Sumer": "0x553d713e0fB958932b6C40ABAf0b5A1fFae73Da2",
        "CompoundLens": "0x863656e346d8A42EC7caAAd606611b6fD8916f32",
        "FeedPriceOracle": "0x873449359d2d99691436E724C6C219a39b159B4a",
        "CompLogic": "0x0f0af0e3dEb8A884fCB54907BA571c84C2EB3042",
        "RedemptionManager": "0x2d9b96648C784906253c7FA94817437EF59Cf226",
        "Timelock": "0x3EC1D6e0B44c8a2a8855aEb71f35355459478482",
        "Comptroller": "0x16C7d1F9EA48F7DE5E8bc3165A04E8340Da574fA",
        "sdrBERA": "0x6116438fD4abDd902dcA8e0335144F700B1a5147",
        "BERA": "0x0000000000000000000000000000000000000000",
        "CErc20": "0x313Ba7E5508e3deb17CD5abA9D7A1b15BdE77879",
        "suErc20": "0x8c1ad24cA39FE45E97CD9862364128406E3B03F3",
        "CInfraredVault": "0x611375907733D9576907E125Fb29704712F0BAfA",
        "JumpRate#StableBC": "0xB325BBf765ff4e65D38BA045D925b80B52f1A37C",
        "JumpRate#Others": "0x332F124323A1DA3Aeca4860f3B2B4a4c0df232Ae",
        "JumpRate#BTCBC_AltStables": "0xd6062F989BCf5DD6871A83671C4aABD05e25BA1b",
        "JumpRate#ETH": "0x9aa55bCf3E41D0d98FCe816C4eC6E791B0f6d154",
        "JumpRate#BERA": "0x768417E8F2d6da8a38d06B69B74C2849b88CB2fe",
        "ZeroRate": "0xBB134359b3E6794127c7232680F959CE6BF60814",
        "sdrUSDC.e": "0xe19FD48C972E2dB074C4B0B29Ff2f0d3E1aefe52",
        "USDC.e": "0x549943e04f40284185054145c6E4e9568C1D3241",
        "sdrHONEY": "0xB2fF02eEF85DC4eaE95Ab32AA887E0cC69DF8d8E",
        "HONEY": "0xFCBD14DC51f0A4d49d5E53C2E0950e0bC26d0Dce",
        "sdrNECT": "0x10A2e256Bed7b3c49C151Ad1Bad01F4936FC9276",
        "NECT": "0x1cE0a25D13CE4d52071aE7e02Cf1F6606F4C79d3",
        "sdrWETH": "0xb1FdC3f660b0953253141B2509c43014d5d3d733",
        "WETH": "0x2F6F07CDcf3588944Bf4C42aC74ff24bF56e7590",
        "sdrSTONE": "0x2CB37855fb2Dc0b4C204E242b6A5f731c22AD4bc",
        "STONE": "0xEc901DA9c68E90798BbBb74c11406A32A70652C3",
        "sdrWBTC": "0xf70B2473e7808eDAeA4A5Cea95996A9B1843D96C",
        "WBTC": "0x0555E30da8f98308EdB960aa94C0Db47230d2B9c",
        "sdrsuUSD": "0x163cEbBD83A4e2821fF06C9b0707A8A64FEc0AbC",
        "suUSD": "0x8bf591eae535f93a242d5a954d3cde648b48a5a8",
        "sdrsuBTC": "0xA6ae238D9CaF65DFA67670FDE3156EFeE9334488",
        "suBTC": "0xe85411C030fB32A9D8b14Bbbc6CB19417391F711",
        "sdrUSDC_HONEY_BEX": "0x341fDb6532154Cec491Aca3D3BB404C2d4cc042E",
        "USDC_HONEY_BEX": "0xF961a8f6d8c69E7321e78d254ecAfBcc3A637621",
        "sdrBYUSD_HONEY_BEX": "0x45f7a835c5b490288ABE36CF3d25a1119135d60F",
        "BYUSD_HONEY_BEX": "0xde04c469ad658163e2a5e860a03a86b52f6fa8c8",
        "sdriBera_wBERA_BEX": "0xE9b2f0c9c4868Db97623876191D268b53d9523f7",
        "iBera_wBERA_BEX": "0x62C030B29a6Fef1B32677499e4a1F1852a8808c0"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrUSDC.e",
            "ctokenAddr": "0xe19FD48C972E2dB074C4B0B29Ff2f0d3E1aefe52",
            "underlySym": "USDC.e",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x549943e04f40284185054145c6E4e9568C1D3241",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrHONEY",
            "ctokenAddr": "0xB2fF02eEF85DC4eaE95Ab32AA887E0cC69DF8d8E",
            "underlySym": "HONEY",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xFCBD14DC51f0A4d49d5E53C2E0950e0bC26d0Dce",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrNECT",
            "ctokenAddr": "0x10A2e256Bed7b3c49C151Ad1Bad01F4936FC9276",
            "underlySym": "NECT",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x1cE0a25D13CE4d52071aE7e02Cf1F6606F4C79d3",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrWETH",
            "ctokenAddr": "0xb1FdC3f660b0953253141B2509c43014d5d3d733",
            "underlySym": "WETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x2F6F07CDcf3588944Bf4C42aC74ff24bF56e7590",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrSTONE",
            "ctokenAddr": "0x2CB37855fb2Dc0b4C204E242b6A5f731c22AD4bc",
            "underlySym": "STONE",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xEc901DA9c68E90798BbBb74c11406A32A70652C3",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrWBTC",
            "ctokenAddr": "0xf70B2473e7808eDAeA4A5Cea95996A9B1843D96C",
            "underlySym": "WBTC",
            "ctokenDecimal": 8,
            "underlyDecimal": 8,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x0555E30da8f98308EdB960aa94C0Db47230d2B9c",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrsuUSD",
            "ctokenAddr": "0x163cEbBD83A4e2821fF06C9b0707A8A64FEc0AbC",
            "underlySym": "suUSD",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x8bf591eae535f93a242d5a954d3cde648b48a5a8",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrsuBTC",
            "ctokenAddr": "0xA6ae238D9CaF65DFA67670FDE3156EFeE9334488",
            "underlySym": "suBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xe85411C030fB32A9D8b14Bbbc6CB19417391F711",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrUSDC_HONEY_BEX",
            "ctokenAddr": "0x341fDb6532154Cec491Aca3D3BB404C2d4cc042E",
            "underlySym": "USDC_HONEY_BEX",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xF961a8f6d8c69E7321e78d254ecAfBcc3A637621",
            "assetGroupId": 1,
            "infraredVaultAddr": "0x1419515d3703d8F2cc72Fa6A341685E4f8e7e8e1"
        },
        {
            "ctokenSym": "sdrBYUSD_HONEY_BEX",
            "ctokenAddr": "0x45f7a835c5b490288ABE36CF3d25a1119135d60F",
            "underlySym": "BYUSD_HONEY_BEX",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xde04c469ad658163e2a5e860a03a86b52f6fa8c8",
            "assetGroupId": 1,
            "infraredVaultAddr": "0xbbb228b0d7d83f86e23a5ef3b1007d0100581613"
        },
        {
            "ctokenSym": "sdriBera_wBERA_BEX",
            "ctokenAddr": "0xE9b2f0c9c4868Db97623876191D268b53d9523f7",
            "underlySym": "iBera_wBERA_BEX",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x62C030B29a6Fef1B32677499e4a1F1852a8808c0",
            "assetGroupId": 4,
            "infraredVaultAddr": "0xd3d50fe6dbbb452ed30c7736d70678e4e0d277c8"
        },
        {
            "ctokenSym": "sdrBERA",
            "ctokenAddr": "0x6116438fD4abDd902dcA8e0335144F700B1a5147",
            "underlySym": "BERA",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": true,
            "permitEnabled": false,
            "underlyAddr": "0x0000000000000000000000000000000000000000"
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#BERA",
            "contract": "JumpRateModelV2",
            "address": "0x768417E8F2d6da8a38d06B69B74C2849b88CB2fe",
            "tokens": [
                "BERA",
                "iBera_wBERA_BEX",
                "BERA"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.2",
            "jumpMultiplierPerYear": "5.4",
            "kink": "0.75"
        },
        {
            "name": "JumpRate#StableBC",
            "contract": "JumpRateModelV2",
            "address": "0xB325BBf765ff4e65D38BA045D925b80B52f1A37C",
            "tokens": [
                "USDC.e",
                "HONEY"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.09333",
            "jumpMultiplierPerYear": "3.2",
            "kink": "0.75"
        },
        {
            "name": "JumpRate#BTCBC_AltStables",
            "contract": "JumpRateModelV2",
            "address": "0xd6062F989BCf5DD6871A83671C4aABD05e25BA1b",
            "tokens": [
                "NECT",
                "WBTC"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.0889",
            "jumpMultiplierPerYear": "5.52727",
            "kink": "0.45"
        },
        {
            "name": "JumpRate#ETH",
            "contract": "JumpRateModelV2",
            "address": "0x9aa55bCf3E41D0d98FCe816C4eC6E791B0f6d154",
            "tokens": [
                "WETH"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.036",
            "jumpMultiplierPerYear": "3.2",
            "kink": "0.75"
        },
        {
            "name": "ZeroRate",
            "contract": "FixedInterestRateModel",
            "address": "0xBB134359b3E6794127c7232680F959CE6BF60814",
            "tokens": [
                "suUSD",
                "suBTC"
            ],
            "initBorrowRate": "0",
            "initSupplyRate": "0"
        },
        {
            "name": "JumpRate#Others",
            "contract": "JumpRateModelV2",
            "address": "0x332F124323A1DA3Aeca4860f3B2B4a4c0df232Ae",
            "tokens": [
                "USDC_HONEY_BEX",
                "BYUSD_HONEY_BEX"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.15555",
            "jumpMultiplierPerYear": "5.582",
            "kink": "0.45"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=beramain.js.map